module.exports = __webpack_public_path__ + "88d787ec888f18514ff33e81aed590b1.jpg";